module.exports = __webpack_public_path__ + "img/ford.10a4ae7f.png";